/** Canonical pickup payment and support contacts. */
export const PAYMENT_ETRANSFER_EMAIL = 'payforhockey@hotmail.com'
export const SINGLE_GAME_PRICE_CAD = 18
